<script>
import fromPairs from 'lodash/fromPairs'
import date from 'locutus/php/datetime/date'
import AdminLayout from '@layouts/admin-main'
import FinanceNav from '@components/admin/finance-nav'
import InstrumentInfo from '@components/admin/finance-instrument-info'
import { mapState } from 'vuex'
import { fetchInstruments, deleteInstrument } from '@apis/admin/finance'

export default {
  page: {
    title: 'Admin::Finance',
    meta: [{ name: 'description', content: 'Admin::Finance' }],
  },
  components: {
    AdminLayout,
    FinanceNav,
    InstrumentInfo,
  },
  data() {
    return {
      instruments: [],
      target_instrument_seq: 0,
      show_instrument_info: false,
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      Promise.all([this.loadInstruments()]).catch((e) =>
        this.$toasted.error(e.message)
      )
    },
    async loadInstruments() {
      const { data } = await fetchInstruments()

      this.instruments = data
    },
    handleCreateInstrument() {
      this.show_instrument_info = true
      this.target_instrument_seq = null
    },
    handleUpdateInstrument({ seq }) {
      this.show_instrument_info = true
      this.target_instrument_seq = seq
    },
    handleInstrumentSubmit(seq) {
      this.init()
      this.target_instrument_seq = seq
    },
    async handleDeleteInstrument(seq) {
      try {
        if (
          !(await this.$confirm(
            this.$t('admin.confirm_delete'),
            this.$t('admin.modal_confirm'),
            {
              type: 'warning',
            }
          ).catch(() => false))
        )
          return

        await deleteInstrument(seq)
        await this.loadInstruments()
      } catch (e) {
        this.$toasted.error(e.message)
      }
    },
    date,
    fromPairs,
  },
}
</script>

<template>
  <AdminLayout>
    <FinanceNav></FinanceNav>
    <div :class="$style.adminLeftContent">
      <h3 :class="$style.xeAdmin">{{
        $t('finance_catalog.financial_product_management')
      }}</h3>
      <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
        <thead>
          <tr>
            <th scope="col"
              ><div>{{ $t('finance_catalog.name') }}</div></th
            >
            <th scope="col"
              ><div>{{ $t('finance_catalog.title') }}</div></th
            >
            <th scope="col"
              ><div>{{
                $t('finance_catalog.number_of_subscriptions')
              }}</div></th
            >
            <th scope="col"
              ><div>{{
                $t('finance_catalog.total_subscription_amount')
              }}</div></th
            >
            <th scope="col">
              <div :class="$style.tRight">
                <a
                  href="#"
                  :class="[$style.button, $style.black]"
                  @click.prevent="handleCreateInstrument"
                  ><span>{{ $t('admin.add') }}</span></a
                >
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="instrument in instruments" :key="instrument.seq">
            <td :class="[$style.tCenter, $style.nowrap]">{{
              instrument.name
            }}</td>
            <td :class="[$style.wide]">{{ instrument.title }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              instrument.opened_count | trimDecimalZero | numberFormat
            }}</td>
            <td :class="[$style.tRight, $style.nowrap]">{{
              instrument.total_opened_amount | trimDecimalZero | numberFormat
            }}</td>
            <td :class="[$style.tRight, $style.nowrap]">
              <a
                href="#"
                :class="[$style.button]"
                @click.prevent="handleUpdateInstrument(instrument)"
                ><span>{{ $t('admin.modify') }}</span></a
              >
              {{ ' ' }}
              <a
                href="#"
                :class="[$style.button, $style.red]"
                @click.prevent="handleDeleteInstrument(instrument.seq)"
                ><span>{{ $t('admin.delete') }}</span></a
              >
            </td>
          </tr>
          <tr v-if="!instruments.length">
            <td :colspan="5" :class="$style.tCenter">{{
              $t('finance_catalog.msg_no_registration')
            }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div :class="$style.adminRightExtra">{{ ' ' }}</div>
    <ElDialog
      :title="
        target_instrument_seq
          ? $t('finance_catalog.modification')
          : $t('finance_catalog.registration')
      "
      :visible.sync="show_instrument_info"
      width="900px"
    >
      <InstrumentInfo
        v-if="show_instrument_info"
        :key="target_instrument_seq"
        :instrument_seq="target_instrument_seq"
        @submit="handleInstrumentSubmit"
      ></InstrumentInfo>
    </ElDialog>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';

.colTable th,
.colTable td {
  vertical-align: middle;
}
</style>
